<script setup lang="ts">
import { ref, toRaw } from 'vue'
import { useModalStore } from '@/store/modal'
import { useAuthStore } from '@/store/auth'
import { MessageCircleQuestion, Loader2 } from 'lucide-vue-next'
import {Button} from '@/components/ui/button'
import { responseStatuses } from '@/utils/constants'
const modal = useModalStore()
const authStore = useAuthStore()
const props = modal.modalProps

const isLoading = ref(false)


</script>

<template>
  <div class="bg-white p-8 rounded-[16px] shadow-lg w-[448px] flex flex-col items-center">

    <div class="flex items-center gap-2 mb-6 h-[48px]">
      <MessageCircleQuestion class="h-full w-full" stroke="indigo"/>
    </div>

    <h2 class="text-[18px] font-semibold text-[#111111] mb-3 text-center">
      Вы уверены, что хотите изменить <br/>статус на 
      "{{ responseStatuses.find((item) => item.code === props.status)?.title }}"
    </h2>
    
    <div class="flex justify-center gap-4 w-full">
      <Button variant="destructive" @click="modal.rejectModal('cancel')">
        Отменить
      </Button>
      <Button variant="default" @click="handleConfirm" class="" :disabled="isLoading">
        <Loader2 v-if="isLoading" class="w-4 h-4 mr-2 animate-spin" />
        {{ isLoading ? 'Подтверждение...' : 'Подтвердить' }}
      </Button>
    </div>
  </div>
</template>

<style scoped>
</style>
